import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiMaximize2, FiX } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { Link } from 'react-router-dom';

const projects = [
  {
    id: 7,
    category: 'Garages',
    img: 'https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/3dd50560b31a59b459f8b975a240e705.jpg',
    title: 'Garage Flake System',
    location: 'Boca, FL'
  },
  {
    id: 8,
    category: 'Garages',
    img: 'https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/3bd83805ec9e38f31c6c1f1848124230.jpg',
    title: 'Garage Flake System',
    location: 'Miami, FL'
  },
  {
    id: 9,
    category: 'Garages',
    img: 'https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/9d7c0d99c122f7922d5a614f4669669d.jpg',
    title: 'Garage Flake System',
    location: 'Deerfield Beach, FL'
  },
  {
    id: 10,
    category: 'Garages',
    img: 'https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/2919b28bb5b3bf676b19d34da1ff8d27.jpg',
    title: 'Garage Flake System',
    location: 'Boca, FL'
  },
  {
    id: 11,
    category: 'Garages',
    img: 'https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/fc3fab2e75af4d4f2f947170aec80c47.jpg',
    title: 'Garage Flake System',
    location: 'Miami, FL'
  },
  {
    id: 3,
    category: 'Garages',
    img: 'https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/b57b6fc9c4fda80eb5277417408644ea.jpg',
    title: 'Classic Flake 3-Car Garage',
    location: 'Houston, TX'
  },
  {
    id: 5,
    category: 'Garages',
    img: 'https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/b57b6fc9c4fda80eb5277417408644ea.jpg',
    title: 'Residential Garage System',
    location: 'Phoenix, AZ'
  },
  {
    id: 1,
    category: 'Custom',
    img: 'https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvcG5n/e530ff22062cf234ad1fe93c554972a5.png',
    title: 'Blue Pearl Striped Garage',
    location: 'Austin, TX'
  },
  {
    id: 2,
    category: 'Custom',
    img: 'https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvcG5n/96d47b13ecbf33a42247dbfc6e91e473.png',
    title: 'Emerald Metallic Finish',
    location: 'Dallas, TX'
  },
  {
    id: 4,
    category: 'Custom',
    img: 'https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/014881d4a2df4917ef772508573f13c5.jpg',
    title: 'Ocean Blue Metallic Lounge',
    location: 'San Antonio, TX'
  },
  {
    id: 6,
    category: 'Custom',
    img: 'https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvcG5n/e530ff22062cf234ad1fe93c554972a5.png',
    title: 'Modern Workshop Flow',
    location: 'Denver, CO'
  }
];

const categories = ['All', 'Garages', 'Warehouses', 'Custom'];

const Gallery = () => {
  const [filter, setFilter] = useState('All');
  const [lightbox, setLightbox] = useState(null);

  const filtered = filter === 'All' ? projects : projects.filter(p => p.category === filter);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <div className="relative h-80 md:h-[500px] flex items-end overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvcG5n/5c980b02fae98bba170d82c1e5aa61c5.png"
            alt="Gallery Header"
            className="w-full h-full object-cover scale-105"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-red-900/80 via-black/50 to-black/80" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 w-full">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            <span className="text-red-400 text-sm font-black tracking-[0.2em] uppercase mb-4 block">Our Portfolio</span>
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-white tracking-tight">Project Gallery</h1>
          </motion.div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-gray-600 text-xl max-w-3xl mb-16 font-light leading-relaxed"
        >
          Browse our completed projects. Every floor is a testament to our obsession with quality, durability, and precision.
        </motion.p>

        {/* Filters */}
        <div className="flex flex-wrap gap-4 mb-16">
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              className={`px-8 py-3 rounded-full font-bold text-sm uppercase tracking-wider transition-all duration-300 ${
                filter === cat
                  ? 'bg-red-600 text-white shadow-lg'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-gray-900 border border-gray-200'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Grid */}
        <motion.div layout className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <AnimatePresence>
            {filtered.map((project, i) => (
              <motion.div
                key={project.id}
                layout
                initial={{ opacity: 0, scale: 0.85 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.85 }}
                transition={{ duration: 0.35 }}
                className={`group relative overflow-hidden rounded-3xl bg-gray-100 cursor-pointer border border-gray-200 shadow-sm hover:shadow-xl transition-shadow ${
                  i === 0 ? 'md:col-span-2 aspect-video' : 'aspect-square'
                }`}
                onClick={() => setLightbox(project)}
              >
                <img
                  src={project.img}
                  alt={project.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent opacity-0 group-hover:opacity-90 transition-opacity duration-500" />

                <div className="absolute inset-0 flex items-end p-8 opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-4 group-hover:translate-y-0">
                  <div className="flex-1">
                    <span className="text-red-400 text-xs font-black uppercase tracking-[0.2em] block mb-2">{project.category} · {project.location}</span>
                    <h3 className="text-white text-2xl font-black drop-shadow-lg">{project.title}</h3>
                  </div>
                  <div className="w-12 h-12 rounded-full bg-blue-600/90 backdrop-blur-sm flex items-center justify-center flex-shrink-0 shadow-lg">
                    <SafeIcon icon={FiMaximize2} className="text-white text-lg" />
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-32"
        >
          <p className="text-gray-600 text-xl mb-8 font-light">Love what you see? Let's create your dream floor.</p>
          <Link to="/contact" className="inline-flex items-center gap-3 px-12 py-5 bg-red-600 hover:bg-blue-700 text-white font-black rounded-full transition-all shadow-lg text-lg">
            Start Your Project Today
          </Link>
        </motion.div>
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {lightbox && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 bg-black/95 backdrop-blur-xl flex items-center justify-center p-4"
            onClick={() => setLightbox(null)}
          >
            <motion.div
              initial={{ scale: 0.85, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.85, opacity: 0 }}
              className="relative max-w-5xl w-full rounded-[2.5rem] overflow-hidden shadow-2xl border border-white/10"
              onClick={e => e.stopPropagation()}
            >
              <img src={lightbox.img} alt={lightbox.title} className="w-full object-cover max-h-[80vh]" />
              <div className="absolute bottom-0 left-0 right-0 p-10 bg-gradient-to-t from-black via-black/80 to-transparent">
                <span className="text-red-400 text-sm font-black uppercase tracking-[0.2em]">{lightbox.category} · {lightbox.location}</span>
                <h3 className="text-white text-4xl font-black mt-2">{lightbox.title}</h3>
              </div>
              <button
                onClick={() => setLightbox(null)}
                className="absolute top-6 right-6 w-12 h-12 rounded-full bg-black/80 backdrop-blur-md flex items-center justify-center text-white hover:bg-red-600 transition-colors shadow-lg border border-white/20"
              >
                <SafeIcon icon={FiX} className="text-xl" />
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Gallery;